import { workflowPolicies as policies } from 'helpers';
import Schema from './schema';


export default class Workflow extends Schema {

  constructor(values) {
    super(policies, values);

    this.setDtoDefinition({
      worktemplate_id: null,
      name: '',
      description: '',
      type: '',
      type_template: 'WF',
      wf_definition: '',
      inventory_id: '',
      inventory_ask: false,
      datamodel_id: 0,
      datamodel_ask: false,
      proyect_id: null,
      playbook_id: '',
      credentials_id: null,
      credentials_ask: false,
      forks: 0,
      limit: '',
      limit_ask: false,
      detail_level: 0,
      work_tags: [],
      work_tags_ask: false,
      omit_tags: [],
      omit_tags_ask: false,
      tags: [],
      instance_groups: 0,
      job_slicing: 0,
      timeout: 0,
      show_changes: false,
      show_changes_ask: false,
      enable_privileges: false,
      alow_exec_callbaks: false,
      activate_concurrent_works: false,
      use_event_cache: false,
      variables: '',
      user_interaction: [],
      userInteraction: [],
      notifications: [
        {
          user: '',
          tipo: '',
        },
      ],
      command_line: '',
    });
  }

  setValues(data) {
    this.values = this.dtoDefinition;
    this.values.notifications = JSON.stringify(this.values.notifications);
    this.setDefaultValues(data);
    this.values.wf_definition = JSON.stringify(data.workflowDefinition);
  }


}
